import { Button } from '@components/button';
import { InfoBox } from '@components/info-box';
import { Stack } from '@components/stack';
import { Text } from '@components/text';
import { useScopedTranslate } from '@locale/translate';

import { Modal, ModalProps, useModal } from 'features/modals';

type SSORequiredModalProps = ModalProps<{
  email: string;
}>;

export const SSORequiredModal = ({ closeModal, email }: SSORequiredModalProps) => {
  const { t } = useScopedTranslate(locale);
  const { showModal } = useModal();

  return (
    <Modal>
      <Modal.Header text={t('header')} />
      <Text text={t('description')} />
      <InfoBox text={t('instructions')} variant="orange" />

      <Modal.Actions>
        <Stack orientation="horizontal" space={4}>
          <Button variant="secondary" onClick={closeModal} text={t('cancel')} />
          <Button
            // @ts-ignore-next-line SSO Signin modal is not typed
            onClick={() => showModal('SSO_SIGNIN', { email })}
            text={t('signin')}
          />
        </Stack>
      </Modal.Actions>
    </Modal>
  );
};

const locale = {
  en: {
    header: 'Single Sign-On required',
    description: 'This company only allows SSO sign-in',
    instructions: 'If you want to login using the SSO method, click the button below',
    cancel: 'Cancel',
    signin: 'Sign in with SAML SSO',
  },
  is: {
    header: 'SSO innskráning nauðsynleg',
    description: 'Þetta fyrirtæki leyfir einungis innskráningu með SAML SSO aðferðinni',
    instructions:
      'Ef þú vilt skrá þig inn með SSO aðferðinni, smelltu þá á takkann hér fyrir neðan',
    cancel: 'Hætta við',
    signin: 'Skrá inn með SAML SSO',
  },
};
